<script setup lang="ts">
/**
 * 根组件。
 *
 * audit U-11（2026-08-13）：加全局 offline banner。
 * 原问题：http.ts 仅 ElMessage.error 一次性 toast，长时间断网无提示。
 * 新策略：监听 online/offline event，断网时顶部常驻 banner（关闭即 dismiss）。
 */
import { onMounted, onUnmounted, ref } from 'vue';
import { RouterView } from 'vue-router';

const isOffline = ref(!navigator.onLine);

function handleOffline() {
  isOffline.value = true;
}
function handleOnline() {
  isOffline.value = false;
}

onMounted(() => {
  window.addEventListener('offline', handleOffline);
  window.addEventListener('online', handleOnline);
});
onUnmounted(() => {
  window.removeEventListener('offline', handleOffline);
  window.removeEventListener('online', handleOnline);
});
</script>

<template>
  <div class="app-root">
    <!-- audit U-11：全局断网 banner -->
    <div v-if="isOffline" class="app-offline-banner" role="alert" aria-live="assertive">
      <span class="app-offline-banner__icon" aria-hidden="true">⚠</span>
      <span class="app-offline-banner__text">
        网络已断开，部分功能不可用。我们会自动重连。
      </span>
    </div>
    <RouterView />
  </div>
</template>

<style scoped>
.app-root {
  /* 占位：让子路由占满高度 */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-offline-banner {
  position: sticky;
  top: 0;
  z-index: 3000; /* 高于 EP 默认 z-index 2000 */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--portal-space-2, 8px);
  padding: 8px 16px;
  background: #fef3c7; /* warning 黄 */
  color: #92400e;
  font-size: 13px;
  font-weight: 500;
  border-bottom: 1px solid #f59e0b;
}

.app-offline-banner__icon {
  font-size: 16px;
  line-height: 1;
}

/* reduced-motion：banner 不加动画，避免断网时闪烁打扰 */
@media (prefers-reduced-motion: reduce) {
  .app-offline-banner {
    transition: none;
  }
}
</style>
